var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "icon-cart-btn",
      class: [_vm.iconCartColor, { disabled: _vm.isProductDisabled }],
      attrs: { disabled: _vm.isProductDisabled, "data-testid": "addToCart" },
      on: {
        click: function($event) {
          return _vm.addToCartClick($event)
        }
      }
    },
    [_c("i", { staticClass: "material-icons" }, [_vm._v("shopping_cart")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }